import { render, staticRenderFns } from "./oidc.component.vue?vue&type=template&id=229b61ae&"
import script from "./oidc.component.vue?vue&type=script&lang=ts&"
export * from "./oidc.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports